import line from "../images/Line1.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import { useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event) => {
    // 👇️ clear all input values in the form
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");
  };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_3b7mxlh",
        "template_mv5nnqn",
        form.current,
        "HUAvnsfNyG_z4pUd9"
      )
      .then(
        (result) => {
          if (result.text === "OK") {
            toast.success("Message Successfully Sent!", {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            handleSubmit();
          }
        },
        (error) => {
          toast.error(error.text, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      );
  };

  return (
    <div className="mt-48 px-4 md:px-12" id="contact">
      <div className="flex">
        <img src={line} alt="" />
        <p>&emsp; Give me a shout</p>
      </div>
      <h2 className="text-4xl uppercase font-semibold mt-12 md:px-24">
        CONTACT ME
      </h2>
      <div className="grid mt-12 md:grid-cols-2 md:px-24">
        <div>
          <div className="flex items-center gap-5">
            <FontAwesomeIcon icon={faUser} className="text-2xl" />
            <p>
              <span className="font-semibold">Name </span>
              <br />
              Kevin Joseph Wines
            </p>
          </div>
          <div className="flex items-center gap-5 mt-10">
            <FontAwesomeIcon icon={faLocationDot} className="text-2xl" />
            <p>
              <span className="font-semibold">Address </span>
              <br />
              Surigao City
            </p>
          </div>
          <div className="flex items-center gap-5 mt-10">
            <FontAwesomeIcon icon={faEnvelope} className="text-2xl" />
            <p>
              <span className="font-semibold">Email </span>
              <br />
              kevinsef94@gmail.com
            </p>
          </div>
          <div className="flex items-center gap-5 mt-10">
            <FontAwesomeIcon icon={faPhone} className="text-2xl" />
            <p>
              <span className="font-semibold">Phone </span>
              <br />
              09955844424
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-0">
          <form onSubmit={sendEmail} ref={form}>
            <div className="flex gap-4 w-[100%] flex-col md:flex-row">
              <input
                onChange={(event) => setName(event.target.value)}
                value={name}
                name="name"
                className="block w-[100%] border border-[#7DCE13] p-2 focus:outline-none"
                type="text"
                placeholder="name"
                required
              />
              <input
                onChange={(event) => setEmail(event.target.value)}
                value={email}
                name="email"
                className="block w-[100%] border border-[#7DCE13] p-2 focus:outline-none"
                type="email"
                placeholder="Email"
                required
              />
            </div>
            <input
              onChange={(event) => setSubject(event.target.value)}
              value={subject}
              name="subject"
              className="block w-[100%] border border-[#7DCE13] p-2 mt-3 focus:outline-none"
              type="text"
              placeholder="Subject"
            />
            <textarea
              onChange={(event) => setMessage(event.target.value)}
              value={message}
              className="block w-[100%] border border-[#7DCE13] p-2 mt-3 focus:outline-none"
              name="message"
              id="message"
              cols="30"
              rows="10"
              placeholder="Message"
              required
            />
            <button
              className="mt-3 block w-full md:w-48 my-10 border hover:border-[#7dce13] uppercase shawdow bg-[#7dce13] p-3 transition-all duration-300 hover:shadow-xl hover:text-white"
              type="submit"
              value="send"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
